import moment from 'moment';
import { EMARPOLDocuments } from '../../marpol/@types';
import {
    EBFL2RecordCode,
    EBFL2RecordState,
    TBFL2CommonData,
    TBFL2CommonFields,
} from '../@types';

export type TBFL2E1Item1 = {
    locationWhereShipConductProactiveCleaning: string;
};

export type TBFL2E1Item2 = {
    contigencyActions: string;
};

export type TBFL2E1Item3 = {
    recordsOfMaintenance: string;
    maintenanceAttachment: string;
};

export type TBFL2E1Item4 = {
    dateWhenShipReturnedToNormal: string;
};

export type TBFL2E1 = TBFL2CommonFields &
    TBFL2CommonData & {
        id: string;
        recordCode: EBFL2RecordCode.BFL2E1;
        item1: TBFL2E1Item1;
        item2: TBFL2E1Item2;
        item3: TBFL2E1Item3;
        item4: TBFL2E1Item4;
    };

export type TBFL2E = TBFL2E1;

const BFL2E_DEFAULTS: {
    E1: TBFL2E1;
} = {
    E1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL2,
        state: EBFL2RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            locationWhereShipConductProactiveCleaning: '',
        },
        item2: {
            contigencyActions: '',
        },
        item3: {
            recordsOfMaintenance: '',
            maintenanceAttachment: ' ',
        },
        item4: {
            dateWhenShipReturnedToNormal: '',
        },
        recordCode: EBFL2RecordCode.BFL2E1,
    },
};

export { BFL2E_DEFAULTS };
